import { Assinante } from "../@types/Assinante";
import Service from "./Service";

class AssinanteService extends Service {
  /** Get all subscribers */
  static getAssinantes() {
    return this.Http.get<Assinante.Assinante[]>("/subscribers").then(
      this.getData,
    );
  }

  /** Get a specific subscriber by ID */
  static getAssinatura() {
    return this.Http.get<Assinante.Assinante>(`/subscribers/byuser`).then(
      this.getData,
    );
  }

  /** Create a new subscriber */
  static create(assinante: Assinante.Assinante) {
    return this.Http.post<Assinante.Assinante>("/subscribers", assinante).then(
      this.getData,
    );
  }

  /** Update subscriber data */
  static update(assinante: Assinante.Assinante) {
    return this.Http.put<Assinante.Assinante>(
      `/subscribers/${assinante.id}`,
      assinante,
    ).then(this.getData);
  }

  /** Delete a subscriber */
  static delete(id: string) {
    return this.Http.delete<void>(`/subscribers/${id}`).then(this.getData);
  }

  /** Toggle active/disabled status */
  static setDisabled(id: string, disabled: boolean) {
    return this.Http.put(
      `/subscribers/${id}/disabled`,
      { disabled },
      { headers: { "Content-Type": "application/json" } },
    ).then(this.getData);
  }
}

export default AssinanteService;
